export type Language = 'ru' | 'en';

export const translations = {
  ru: {
    appName: 'Новкъаст GO',
    // Header
    whereToGo: 'Куда едем?',
    currentLocation: 'Назрань, ул. Муталиева',
    
    // Services
    taxi: 'Такси',
    taxiDesc: 'Быстрая подача за 3 минуты',
    food: 'Доставка еды',
    foodDesc: 'Из любимых ресторанов',
    delivery: 'Доставка',
    deliveryDesc: 'Посылки и документы',
    
    // Promo
    promoTitle: 'Акции и предложения',
    promoDiscount: '-30% на первую поездку',
    promoCode: 'Используйте промокод WELCOME30',
    promoButton: 'Получить',
    
    // Restaurant
    addToCart: 'Добавить',
    cart: 'Корзина',
    order: 'Заказать',
    deliveryAddress: 'Адрес доставки',
    orderComment: 'Комментарий к заказу',
    applyPromo: 'Применить промокод',
    subtotal: 'Сумма заказа',
    discount: 'Скидка',
    total: 'Итого',
    
    // Delivery
    deliveryTitle: 'Доставка',
    deliveryWhat: 'Что доставить?',
    deliveryFrom: 'Откуда',
    deliveryTo: 'Куда',
    recipientName: 'Имя получателя',
    recipientPhone: 'Телефон получателя',
    deliverySpeed: 'Скорость доставки',
    deliveryFast: 'Быстро',
    deliveryEconomy: 'Экономия',
    
    // Quick Actions
    quickActions: 'Быстрые действия',
    home: 'Домой',
    work: 'На работу',
    
    // Navigation
    main: 'Главная',
    history: 'История',
    profile: 'Профиль',
    login: 'Войти',
    signup: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    fullName: 'Полное имя',
    phone: 'Телефон',
    welcomeBack: 'С возвращением!',
    createAccount: 'Создать аккаунт',
    
    // Taxi Page
    orderTaxi: 'Заказ такси',
    from: 'Откуда',
    to: 'Куда',
    tariffs: 'Тарифы',
    economy: 'Эконом',
    comfort: 'Комфорт',
    business: 'Бизнес',
    orderFor: 'Заказать за',
    stop: 'Остановка',
    comment: 'Комментарий',
    options: 'Опции',
    
    // Active Orders
    activeOrders: 'Активные заказы',
    noActiveOrders: 'Нет активных заказов',
    orderInProgress: 'Заказ в пути',
    arrivalTime: 'Прибытие через',
    minutes: 'мин',
    
    // Stats
    totalRides: 'Поездок',
    totalOrders: 'Заказов',
    savedMoney: 'Сэкономлено',
    
    // Ingushetia specific
    halal: 'Халяль',
    halalOnly: 'Только халяль',
    halalDesc: '100% халяль еда',
    femaleDriver: 'Водитель-женщина',
    femaleDriverDesc: 'Для вашего комфорта',
    familyOrder: 'Семейный заказ',
    familyOrderDesc: 'На несколько адресов',
    celebrationOrder: 'Праздничный заказ',
    celebration: 'Праздничное',
    celebrationDesc: 'Подарки и торжества',
    wedding: 'Свадьба',
    birthday: 'День рождения',
    memorial: 'Поминки',
    payOnDelivery: 'Оплата при получении',
    cashPayment: 'Оплата наличными',
    callDriver: 'Позвонить',
    
    // Greetings
    goodMorning: 'Доброе утро!',
    goodAfternoon: 'Добрый день!',
    goodEvening: 'Добрый вечер!',
    guestMode: 'Добро пожаловать!',
    
    // Quick links
    support: 'Поддержка',
    bonuses: 'Бонусы',
    
    // Cuisine types
    ingushCuisine: 'Ингушская',
    chechenCuisine: 'Чеченская',
    caucasianCuisine: 'Кавказская',
    russianCuisine: 'Русская',
    asianCuisine: 'Азиатская',
    europeanCuisine: 'Европейская',
    fastFood: 'Фаст-фуд',
    
    // Cities
    nazran: 'Назрань',
    magas: 'Магас',
    karabulak: 'Карабулак',
    sunzha: 'Сунжа',
  },
  en: {
    appName: 'Nowkast GO',
    // Header
    whereToGo: 'Where to go?',
    currentLocation: 'Nazran, Mutaliev St.',
    
    // Services
    taxi: 'Taxi',
    taxiDesc: 'Fast pickup in 3 minutes',
    food: 'Food Delivery',
    foodDesc: 'From your favorite restaurants',
    delivery: 'Delivery',
    deliveryDesc: 'Parcels and documents',
    
    // Promo
    promoTitle: 'Promotions and Offers',
    promoDiscount: '-30% on first ride',
    promoCode: 'Use promo code WELCOME30',
    promoButton: 'Get it',
    
    // Restaurant
    addToCart: 'Add to cart',
    cart: 'Cart',
    order: 'Order',
    deliveryAddress: 'Delivery address',
    orderComment: 'Order comment',
    applyPromo: 'Apply promo code',
    subtotal: 'Subtotal',
    discount: 'Discount',
    total: 'Total',
    
    // Delivery
    deliveryTitle: 'Delivery',
    deliveryWhat: 'What to deliver?',
    deliveryFrom: 'From',
    deliveryTo: 'To',
    recipientName: 'Recipient name',
    recipientPhone: 'Recipient phone',
    deliverySpeed: 'Delivery speed',
    deliveryFast: 'Fast',
    deliveryEconomy: 'Economy',
    
    // Quick Actions
    quickActions: 'Quick Actions',
    home: 'Home',
    work: 'Work',
    
    // Navigation
    main: 'Main',
    history: 'History',
    profile: 'Profile',
    login: 'Login',
    signup: 'Sign Up',
    email: 'Email',
    password: 'Password',
    fullName: 'Full Name',
    phone: 'Phone',
    welcomeBack: 'Welcome back!',
    createAccount: 'Create Account',
    
    // Taxi Page
    orderTaxi: 'Order Taxi',
    from: 'From',
    to: 'To',
    tariffs: 'Tariffs',
    economy: 'Economy',
    comfort: 'Comfort',
    business: 'Business',
    orderFor: 'Order for',
    stop: 'Stop',
    comment: 'Comment',
    options: 'Options',
    
    // Active Orders
    activeOrders: 'Active Orders',
    noActiveOrders: 'No active orders',
    orderInProgress: 'Order in progress',
    arrivalTime: 'Arrival in',
    minutes: 'min',
    
    // Stats
    totalRides: 'Rides',
    totalOrders: 'Orders',
    savedMoney: 'Saved',
    
    // Ingushetia specific
    halal: 'Halal',
    halalOnly: 'Halal only',
    halalDesc: '100% halal food',
    femaleDriver: 'Female driver',
    femaleDriverDesc: 'For your comfort',
    familyOrder: 'Family order',
    familyOrderDesc: 'Multiple addresses',
    celebrationOrder: 'Celebration order',
    celebration: 'Celebration',
    celebrationDesc: 'Gifts and events',
    wedding: 'Wedding',
    birthday: 'Birthday',
    memorial: 'Memorial',
    payOnDelivery: 'Pay on delivery',
    cashPayment: 'Cash payment',
    callDriver: 'Call',
    
    // Greetings
    goodMorning: 'Good morning!',
    goodAfternoon: 'Good afternoon!',
    goodEvening: 'Good evening!',
    guestMode: 'Welcome!',
    
    // Quick links
    support: 'Support',
    bonuses: 'Bonuses',
    
    // Cuisine types
    ingushCuisine: 'Ingush',
    chechenCuisine: 'Chechen',
    caucasianCuisine: 'Caucasian',
    russianCuisine: 'Russian',
    asianCuisine: 'Asian',
    europeanCuisine: 'European',
    fastFood: 'Fast food',
    
    // Cities
    nazran: 'Nazran',
    magas: 'Magas',
    karabulak: 'Karabulak',
    sunzha: 'Sunzha',
  },
};

export const getTranslation = (lang: Language) => translations[lang];

export const languageNames: Record<Language, string> = {
  ru: 'Русский',
  en: 'English',
};
